import oss from 'ali-oss';
import http from '@/api/base';

export const UploadToOss = (self, path, file) => {
  const url = uploadPath(path, file);
  return new Promise(async (resolve, reject) => {
    const ossInstance = await client(self);
    ossInstance
      .multipartUpload(url, file)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const uploadPath = (path, file) => {
  // 上传文件的路径，使用日期命名文件目录
  let timeStamp = new Date().getTime();
  return `${timeStamp}_${Math.round(Math.random() * 10000)}.${
    file.type.split('/')[1]
  }`;
};

// 本地上传新的oss 包含标题导出  ulr路径随机不能动 只能通过修改返回参数的方式返回有一个titile
export const UploadToOssLocal = (self, path, file) => {
  const url = uploadPathLocal(path, file);
  return new Promise(async (resolve, reject) => {
    const ossInstance = await client(self);
    ossInstance
      .multipartUpload(url, file)
      .then((data) => {
        let newData = { ...data }
        newData.title = file?.name.split('.')[0]
        resolve(newData);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const uploadPathLocal = (path, file) => {
  // 上传文件的路径，使用日期命名文件目录
  let timeStamp = new Date().getTime();
  return `userCollLocalUpload/${timeStamp}_${Math.round(Math.random() * 10000)}.${file.type.split("/")[1]
    }`;
};

export const client = async (self) => {
  try {
    // const {
    //   token: {
    //     access_key_id,
    //     access_key_secret,
    //     // stsToken,
    //     // OSS_ENDPOINT,
    //     OSS_BUCKET,
    //     OSS_REGION,
    //   },
    // } = self.state || self;

    const { token } = self.state || self;
    let params = { ...token };
    const res = await http.get('https://manager.znztv.com/manager/credential/getUploadCredentialSTSQingTu');
    if (res?.error?.errorCode == 0) {
      params.access_key_id = res?.data?.ak;
      params.access_key_secret = res?.data?.sk;
      params.stsToken = res?.data?.token;
    }

    return new oss({
      accessKeyId: params.access_key_id,
      accessKeySecret: params.access_key_secret,
      stsToken: params.stsToken,
      region: params.OSS_REGION,
      bucket: params.OSS_BUCKET,
    });
    
  } catch (error) {
    console.log('error: ', error);
  }
};